import React from 'react';
// import Logo from '../assets/Images/logo.png';
import { Link } from 'react-router-dom';
// import { ReactComponent as CallIcon } from '../assets/icons/call-icon.svg';
// import { ReactComponent as EmailIcon } from '../assets/icons/email-icon.svg';
// import { ReactComponent as MapIcon } from '../assets/icons/map.svg';
// import CounterTopdivider from '../assets/Images/layered-wave.svg';

const Footer = () => {
    return (
        <footer>
            <div className="copyright">
                <p>Copyright © 2025 <Link to='/'>AVNA</Link>. All Rights Reserved. Design & Developed by
                    <Link to="https://inspirefox.com/" target='_blank'> InspireFox</Link>
                </p>
            </div>
        </footer>
    );
};

export default Footer;